import React, { useState, useEffect } from 'react';
import { getHouseRules } from '@/lib/api';
import { BookOpen, Loader2 } from 'lucide-react';

export default function HouseRules() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getHouseRules().then(setData).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-[#3A4035] animate-spin" /></div>;

  return (
    <div className="animate-fade-in" data-testid="house-rules-page">
      <div className="mb-8">
        <h1 className="font-heading text-2xl sm:text-3xl font-medium text-[#1A1A1A] tracking-tight">{data?.title || 'House Rules'}</h1>
        <p className="text-sm text-[#5C5C55] mt-1">Please familiarise yourself with these guidelines</p>
      </div>

      <div className="space-y-6">
        {(data?.rules || []).map((section, i) => (
          <div key={section.category} className={`bg-white rounded-2xl border border-[#E5E2DC] shadow-[0_2px_10px_rgba(0,0,0,0.02)] p-6 animate-fade-in stagger-${i + 1}`}>
            <h2 className="font-heading text-base font-medium text-[#1A1A1A] mb-4">{section.category}</h2>
            <ul className="space-y-3">
              {section.items.map((item, j) => (
                <li key={item} className="flex items-start gap-3 text-sm text-[#5C5C55]">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#3A4035] mt-2 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
